<template>
  <div id="login">
    <form id="login-form" @submit.prevent="submitForm">
      <div class="row align-center">
        <div class="small-12 medium-5 columns">
          <input type="text" class="text-center" ref="login" v-model="username" :placeholder="'User name'|t" required="required" autofocus minlength="3" maxlength="64" />
          <input type="password" class="text-center" v-model="password" :placeholder="'Password'|t" required="required" minlength="5" maxlength="64" />
          <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
          <div class="text-center"><router-link to="/recover" tag="a">{{ 'Lost password?'|t }}</router-link></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import router from '@/routes'

  export default {
    name: 'Login',
    data() {
      return {
        username: "",
        password: ""
      }
    },
    computed: {
      authenticated() {
        return this.$store.getters['auth/isAuthed']
      },
      administrator() {
        return this.$store.getters['auth/isAdmin']
      }
    },
    methods: {
      submitForm() {
        this.$store.dispatch('auth/login', {name: this.username, password: this.password});
      }
    },
    created() {
      if (this.authenticated) {
        router.push({name: 'admin'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue